import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeSolutions } from '../components/home/HomeSolutions';
import { HomeActionExamples } from '../components/home/HomeActionExamples';
import { HomeFoundations } from '../components/home/HomeFoundations';
import { HomeEcosystem } from '../components/home/HomeEcosystem';
import { HomeResearch } from '../components/home/HomeResearch';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-3013" data-mp="2s1xtg3aehs2p" />
      <HomeSolutions data-id="element-3014" data-mp="2s2gzomqous0w" />
      <HomeActionExamples data-id="element-3015" data-mp="2s2z3c4fok8iu" />
      <HomeFoundations data-id="element-3016" data-mp="2rzl3b2uhobek" />
      <HomeEcosystem data-id="element-3017" data-mp="36qu0bx0q0z1q" />
      <HomeResearch data-id="element-3018" data-mp="36rdgb86t9dd4" />
      <HomeCTA data-id="element-3019" data-mp="36rmy48hpce7q" />
    </>;
}